export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const USER_NAME = "USER_NAME";
export const USER_ID = "USER_ID";
export const USER_ROLES = "USER_ROLES";
export const BASE_URL_TADA_AYANA = process.env.VUE_APP_BASE_URL_API;
